import './index.css';
import React from 'react';
import Constants from '../../constants';
import I18n from '../../utilities/locale';
import View from '../view';
import Text from '../text';
import useTheme from '../../utilities/hooks/theme';

type PlayingHistoryItemProps = {
  Icon: any;
  title: any;
  value: any;
};

const PlayingHistoryItem = ({ Icon, title, value }: PlayingHistoryItemProps) => {
  const { ComponentTheme: theme } = useTheme();
  return (
    <View className={'user-playing-history-content-item-wrapper'}>
      <Icon
        width={35}
        height={35}
        fillPrimary={theme.svgPrimary}
        fillSecondary={theme.svgSecondary}
      />
      <View className={'user-playing-history-content-item-title-wrapper'}>
        <Text
          style={{
            color: theme.playingHistoryValue
          }}
          className={'user-playing-history-value'}>{`${value}`}</Text>
        <Text
          style={{
            color: theme.playingHistoryTitle
          }}
          className={'user-playing-history-title'}>{`${title}`}</Text>
      </View>
    </View>
  );
};

type Props = {
  totalMatchPlayed: Object;
  totalContestPlayed: Object;
  totalContestWon: Object;
  totalWinning: Object;
};

const UserPlayingHistory = ({
  totalMatchPlayed,
  totalContestPlayed,
  totalContestWon,
  totalWinning
}: Props) => {
  const { ComponentTheme: theme } = useTheme();

  return (
    <View
      style={{ backgroundColor: theme.playingHistoryContainerBG }}
      className={'user-playing-history-container'}>
      <View className={'user-playing-history-content-wrapper'}>
        <PlayingHistoryItem
          Icon={Constants.Svgs.PlayingHistoryWinnings}
          title={I18n.t('TotalWinning')}
          value={`₹${totalWinning}`}
        />
        <PlayingHistoryItem
          Icon={Constants.Svgs.PlayingHistoryMatchPlayed}
          title={I18n.t('TotalMatchPlayed')}
          value={totalMatchPlayed}
        />
      </View>
      <View className={'user-playing-history-content-wrapper'}>
        <PlayingHistoryItem
          Icon={Constants.Svgs.PlayingHistoryContestsPlayed}
          title={I18n.t('TotalContestPlayed')}
          value={totalContestPlayed}
        />
        <PlayingHistoryItem
          Icon={Constants.Svgs.PlayingHistoryContestWon}
          title={I18n.t('TotalContestWon')}
          value={totalContestWon}
        />
      </View>
    </View>
  );
};
export default React.memo(UserPlayingHistory);
